import { Location } from "../../schema/types/location/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export interface LocationTableItem extends Location {
  selfLink: string;
}

interface GetLocationTableItemProps {
  link?: string;
  name?: string;
  item?: Location;
}
export function getLocationTableItem({ link, name, item }: GetLocationTableItemProps): LocationTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "location",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      provider: "" as any,
      origin: "default",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "location",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    provider: "" as any,
    origin: "default",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
